export default {"src":"/_next/static/media/bikeAccessories_64.d6fb3122.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};